module.exports = __webpack_public_path__ + "img/selfhelpicon.09708f4f.png";